import { Col, Row, Spin, Typography } from "antd";

const LoadingSpinner = () => {
    return (
        <Spin size="large" style={{ backgroundColor: 'transparent' }}>
            <Row justify="center">
                <Col xs={24} sm={22} md={20} lg={18} xl={16} className="loadingColApp">
                    <Typography.Title level={2} type="secondary">
                        Loading. Please wait!
                    </Typography.Title>
                </Col>
            </Row>
        </Spin>
    );
};

export default LoadingSpinner;